'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function FormContent({ children }: { children: React.ReactNode }) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-start justify-start gap-4',
        'ea-form-content__container',
      )}
    >
      {children}
    </div>
  );
}
